interface IProps {
    color?: string;
}
import { enumTheme } from "@configs";
import { selectMerchant } from "@redux";
import { useSelector } from "react-redux";
import styled from "styled-components";
import {
    LeftTopInner,
    LeftTopOuter,
    RightBottom,
    RightBottomInner,
    SpotLayer,
    SpotLeftLayer,
} from "../icon";

export const Banner = (props: IProps) => {
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || "light";
    const { color } = props;
    const modeColor = themeMode === enumTheme.DARK ? "#000000" : color;
    return (
        <>
            <StyledLeftSide>
                <StyledInnerLayout>
                    <LeftTopInner />
                    <LeftTopOuter color={modeColor} />
                    <SpotLeftLayer />
                </StyledInnerLayout>
            </StyledLeftSide>
            <StyledRightSide>
                <StyledInnerLayout>
                    <SpotLayer />
                    <RightBottomInner />
                    <RightBottom />
                </StyledInnerLayout>
            </StyledRightSide>
            ;
        </>
    );
};
const StyledLeftSide = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 45%;
    height: 100%;
`;
const StyledRightSide = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 55%;
    height: 100%;
`;
const StyledInnerLayout = styled.div`
    width: 100%;
    height: 100%;
    .spot {
        position: absolute;
        bottom: 22px;
        right: 2px;
    }
    .rightBottomInner {
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .rightBottom {
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .spotLeftLayer {
        position: absolute;
        bottom: 0;
        left: -3px;
    }
    .leftTopInner {
        position: absolute;
        left: 0;
        top: 0;
    }
    .leftTopOuter {
        position: absolute;
        left: 0;
        top: 0;
    }
`;
